export default function SettingsPage() {
  return (
    <div className="space-y-4">
      <h1 className="text-xl font-semibold">Settings</h1>
      <p className="text-slate-500">Settings placeholder</p>
    </div>
  );
}
